import { safeDivide, summarizeMetricsArray } from "../math";
import { type InsightsMetrics, type StatsItem } from "../models";

export const mapAverageStatAverageValue = (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => ({
    ...computedMetric,
    averageValue: safeDivide(summarizeMetricsArray(computedMetric.stats), computedMetric.stats.length),
});
